import * as React from "react";
const SvgRouteVia = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "currentColor", stroke: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 6, r: 5.75, strokeWidth: 0.5, fillOpacity: 0.5 }));
export default SvgRouteVia;
